(($) => {
    "use strict";

    $.enhancer("newsList", function () {
        const newsList = $(this);

        newsList.on('click', '#next-btn',
            (e) => {

                $('#loading-animation').show();
                e.preventDefault();
                var page = +$("#news-list-page").val() + 1;
                updateView(page);
            });

        function updateView(page) {
            var url = newsList.find("#news-list-url").val();
            var requestUrl = url.replace('{page}', page);
            $.ajax({
                url: requestUrl,
                dataType: 'html',
                timeout: 15000,
                cache: false,
                success: function (data) {
                    $("#news-list").html(data);
                    updateHistory(requestUrl);
                },
                error: function (xhr, status, error) {
                    console.log('Ooops! Något gick fel i searchHandler');
                }
            });

        }
        function updateHistory(requestUrl) {

            const formatedUrl = requestUrl.substring(requestUrl.indexOf("?"));

            let stateObj = {
                url: formatedUrl,
            };

            // Update url, dont update the history
            history.replaceState(null, null, formatedUrl);
        }
    });
})(jQuery);